import { render, staticRenderFns } from "./AdminSupport.vue?vue&type=template&id=45814f6a&scoped=true&"
import script from "./AdminSupport.vue?vue&type=script&lang=js&"
export * from "./AdminSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45814f6a",
  null
  
)

export default component.exports